import { ref, onMounted, onUnmounted } from "vue";

export function useScrollNav() {
  const isScrolled = ref(false);
  const scrollY = ref(0);

  const handleScroll = () => {
    scrollY.value = window.scrollY;
    // 根据视口高度的 60% 来判断
    const triggerPoint = window.innerHeight * 0.6;
    isScrolled.value = window.scrollY > triggerPoint;
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });

  return {
    isScrolled,
    scrollY,
  };
}
